import { render } from "./ForgotPassword.vue?vue&type=template&id=4163a233"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script